import React, { useEffect, useRef, useState } from "react";
import "./EditarFabricanteEstaleiroModal.css";

const sanitizeTextInput = (value, max = 80) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeTextSave = (value, max = 80) => sanitizeTextInput(value, max).trim();

export default function EditarFabricanteEstaleiroModal({ open, registro, onClose, onSalvar }) {
  const [fabricante, setFabricante] = useState("");
  const [modelo, setModelo] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const fabricanteRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setFabricante(sanitizeTextInput(registro?.fabricante || ""));
    setModelo(sanitizeTextInput(registro?.modelo || ""));
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => fabricanteRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open, registro]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const fabricanteValue = sanitizeTextSave(fabricante);
      const modeloValue = sanitizeTextSave(modelo);
      if (!fabricanteValue) throw new Error("Informe o fabricante.");
      await onSalvar?.({ fabricante: fabricanteValue, modelo: modeloValue });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar alteracoes.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="fbeed-overlay" onClick={onClose}>
      <div className="fbeed-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Editar fabricante">
        <div className="fbeed-head">
          <h3 className="fbeed-title">Editar Fabricante</h3>
          <button className="fbeed-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="fbeed-body">
          <label className="fbeed-field">
            <span>Fabricante</span>
            <input
              ref={fabricanteRef}
              type="text"
              value={fabricante}
              onChange={(e) => setFabricante(sanitizeTextInput(e.target.value))}
              autoComplete="off"
            />
          </label>
          <label className="fbeed-field">
            <span>Modelo (opcional)</span>
            <input
              type="text"
              value={modelo}
              onChange={(e) => setModelo(sanitizeTextInput(e.target.value))}
              autoComplete="off"
            />
          </label>
          {err ? <div className="fbeed-error">{err}</div> : null}
        </div>

        <div className="fbeed-foot">
          <button className="fbeed-btn fbeed-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="fbeed-btn fbeed-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alteracoes"}
          </button>
        </div>
      </div>
    </div>
  );
}
